import { RecommendationFragmentType } from '../../types'
import { BaseNode } from '../../actionCard'

export class RecommendationNode extends BaseNode {
  declare data: RecommendationFragmentType
}
